import React, { Component } from 'react';
import { Link, IndexLink } from 'react-router-dom'
import { withRouter } from 'react-router'

class Header extends Component {
  // static propTypes = {
  //   location: React.PropTypes.object.isRequired
  // }

  render() {
    return (
      <nav>
        <Link to="/">
          <div title="Home" className="brand"></div>
        </Link>
      </nav>
    );
  }
}

export default withRouter(Header)



// WEBPACK FOOTER //
// ./src/Components/Header/MarketingHeader.js